<nav class="navbar navbar-expand-md navbar-dark bg-black">
    <div class="container">
        <div class="navbar-brand">
            <div class="brand_area ">
                <div class="brand1">
                    <a class="nasa_logo" href="http://www.nasa.gov" title="NASA">NASA</a>
                </div>
                <div class="brand2">
                    <div class="jpl_logo">
                        <a href="//www.jpl.nasa.gov/" id="jpl_logo" title="Jet Propulsion Laboratory">Jet Propulsion
                            Laboratory</a>
                    </div>
                    <div class="caltech_logo">
                        <a href="http://www.caltech.edu/" id="caltech_logo" title="California Institute of Technology"
                           target="_blank">California Institute of Technology</a>
                    </div>
                </div>
                <!--<img alt="" class="print_only print_logo" src="../assets/images/logo_nasa_trio_black@2x.png">-->
            </div>
        </div>
        <!--<a class="navbar-brand d-lg-none" href="#">Visit Invitation</a>-->
        <button *ngIf="!loggedIn" class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText"
                aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div *ngIf="loggedIn" class="collapse navbar-collapse" id="navbarText">
            <div class="navbar-nav mr-auto" style="color: #FFF;">
                &nbsp;<a class="visit_invitation" href="/request/overview" *ngIf="!isOnboarding">Visit Invitation</a>
                &nbsp;<a class="visit_invitation" *ngIf="isOnboarding">JPL Invitation</a>
                <!--<li class="nav-item">-->
                    <!--<a class="nav-link" routerLink="{{person_router_link}}" routerLinkActive="active">My Information</a>-->
                <!--</li>-->
                <!--<li class="nav-item">-->
                    <!--<a class="nav-link" routerLink="{{visit_router_link}}" routerLinkActive="active">My Visit</a>-->
                <!--</li>-->
            </div>
            <span class="navbar-text">
                <a class="nav_link" *ngIf="isLoggedIn() && !isOnboarding" (click)="tutorial()">Video Tutorial</a>
<!--                 <a class="nav_link" *ngIf="isLoggedIn() && isOnboarding" (click)="obtutorial()">Video Tutorial</a> -->
                <a class="nav_link logout_btn" *ngIf="isLoggedIn()" (click)="logout()">Logout</a>
            </span>
        </div>
    </div>
</nav>
